
import React from 'react';

const SplitRow = () => (
	<div className="row">
        <div className="offset-sm-1 col-md-10">
            <hr />
        </div>
    </div>
);

export default SplitRow;


// WEBPACK FOOTER //
// ./components/general/SplitRow.js